import LayoutBasic from '../layouts/layoutBasic'
import { withRouter } from 'next/router'
import {GET} from '../helpers'
import {TOKEN, GET_USER_URL, CART} from '../vars'
import {setLocalKeyValue, getLocalKeyValue} from '../storage'

class PrivacyPolicy extends React.Component {


  static async getInitialProps(props) {
    let token =  await process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token

    let infoRequest, infoResponse={}
    if(token) {
      try {
        infoRequest = await GET(GET_USER_URL, token)
        infoResponse = await infoRequest.data
      } catch (e) {

      }
    }

    return {
      token: token,
      user: infoResponse.user,
      cart: infoResponse.cart,
    }
  }
  render () {

  return <LayoutBasic title="Privacy Policy" {...this.props}>
    <div className="licence container font-small mt-5">
      <div className="row">
        <div className="col-sm-12">
          <h1 className="title mb-4">
            Privacy Policy
          </h1>

          <p>
            <strong>Picxy Pro Technologies</strong><br />
            Registered Office: Visakhapatnam, Andhra Pradesh, India<br />
            Last Updated: 24 July 2026
          </p>

          <h2 className="mt-4">1. Introduction</h2>

          <p>This Privacy Policy explains how Picxy Pro Technologies ("Picxy," "we," "us," "our") collects, uses, stores, and protects personal information of users ("you," "your") of our platform, picxy.com (the "Platform"), in connection with our services:</p>

          <ol>
            <li>Photography &amp; Videography Booking Services</li>
            <li>AI Face Sync</li>
            <li>Instashot (Instant Reel Services)</li>
          </ol>

          <p><strong>Note:</strong> Picxy no longer offers stock image licensing on this Platform. This Policy does not apply to any previously offered stock image licensing service.</p>

          <h2 className="mt-4">2. Information We Collect</h2>

          <h3>2.1 Information Provided by You</h3>
          <ul>
            <li>Name, email address, phone number, and billing details when booking a service.</li>
            <li>Event details (date, venue, type of event) provided at the time of booking.</li>
            <li>Payment information processed via our payment gateway partner, RazorPay &amp; PhonePe (Picxy does not store full payment card details on its own servers).</li>
          </ul>

          <h3>2.2 Facial Recognition Data (AI Face Sync)</h3>
          <ul>
            <li>When you use or are photographed at an event using our AI Face Sync service, we process facial images to match and organize photographs specific to you within an event gallery.</li>
            <li>This may include creation of facial embeddings/templates used solely for the purpose of matching your face to relevant event photo.</li>
            <li>This data is stored for <strong>one (1) year</strong> from the date of the event, or longer if you opt for a validity extension package or add-on.</li>
            <li>Facial recognition data is used <strong>only</strong> for gallery-matching purposes within the specific event for which it was collected, and is not used for any other purpose without your consent.</li>
          </ul>

          <h3>2.3 Content Data</h3>
          <ul>
            <li>Photographs, videos, and edited reels created as part of your booked service.</li>
          </ul>

          <h2 className="mt-4">3. How We Use Your Information</h2>

          <p>We use collected information to:</p>
          <ul>
            <li>Process and fulfil your bookings for photography, AI Face Sync, and Instashot services.</li>
            <li>Match and deliver relevant photos to you via AI Face Sync to registered WhatsApp number.</li>
            <li>Process payments and Contributor payouts.</li>
            <li>Communicate with you regarding bookings, deliveries, and support requests.</li>
            <li>Improve our Platform and services.</li>
            <li>Comply with applicable legal obligations.</li>
          </ul>

          <h2 className="mt-4">4. Data Sharing</h2>

          <p>We may share personal information with:</p>
          <ul>
            <li><strong>Contributors</strong> (photographers/videographers/reel creators) assigned to your event, to the extent necessary to fulfil the service.</li>
            <li><strong>Payment gateway providers</strong> for processing payments.</li>
            <li><strong>Cloud storage providers</strong> for hosting event photographs, videos, and facial recognition data securely.</li>
            <li>Government or regulatory authorities, where required by law.</li>
          </ul>

          <p>We do not sell your personal information to third parties.</p>

          <h2 className="mt-4">5. Data Retention</h2>

          <ul>
            <li>General booking and account information is retained as long as necessary to provide services and comply with legal obligations.</li>
            <li>Facial recognition data and associated event galleries are retained for <strong>one (1) year</strong> from the event date, extendable through a selected package or add-on, after which such data may be deleted or archived.</li>
          </ul>

          <h2 className="mt-4">6. Your Rights</h2>

          <p>Subject to applicable law, you may:</p>
          <ul>
            <li>Request access to the personal information we hold about you.</li>
            <li>Request correction of inaccurate information.</li>
            <li>Request deletion of your personal information, including facial recognition data, subject to any ongoing service obligations.</li>
            <li>Withdraw consent for processing of your facial data, which may limit your ability to use AI Face Sync.</li>
          </ul>

          <p>To exercise these rights, contact us at <a href="mailto:support@picxy.com">support@picxy.com</a>.</p>

          <h2 className="mt-4">7. Data Security</h2>

          <p>We implement reasonable technical and organizational measures to protect your personal information, including facial recognition data, against unauthorized access, alteration, disclosure, or destruction.</p>

          <h2 className="mt-4">8. Grievance Officer</h2>

          <p>In accordance with applicable Indian data protection laws, the Grievance Officer for Picxy Pro Technologies can be contacted at:</p>

          <p>
            Email: <a href="mailto:support@picxy.com">support@picxy.com</a><br />
            Address: Visakhapatnam, Andhra Pradesh, India
          </p>

          <h2 className="mt-4">9. Changes to This Policy</h2>

          <p>We may update this Privacy Policy from time to time. Continued use of the Platform after changes are posted constitutes acceptance of the updated Policy.</p>

          <h2 className="mt-4">10. Contact Us</h2>

          <p>For questions about this Privacy Policy, contact us at:</p>

          <p>
            📧 Email: <a href="mailto:support@picxy.com">support@picxy.com</a><br />
            📞 Phone: <a href="tel:+918885558235">+91 8885558235</a>
          </p>
          
          </div>
      </div>
    </div>
  </LayoutBasic>

}
}

export default withRouter(PrivacyPolicy)
